// extracted by mini-css-extract-plugin
export default {"note":"note-module___note___a172d1f3"};